'use client'

import {Modal as KitModal, ModalProps} from 'antd'
import React from 'react'
import styled from 'styled-components'

import {cn} from '@/src/shared/utils/functions'

export interface IProps extends ModalProps {
  open: boolean
  onClose?: () => void
}

const Modal = ({children, open, className, onClose, ...props}: IProps) => {
  return (
    <UI.Modal
      as={KitModal}
      open={open}
      className={cn(className, 'modal')}
      getContainer="#body"
      onCancel={onClose}
      footer={null}
      {...props}>
      {children}
    </UI.Modal>
  )
}

const UI = {
  Modal: styled(KitModal)`
    & .ant-modal-content {
      padding: 45px;
    }
  `,
}

export default Modal
